import Loading from '@@/core/components/shared/Loading/Loading'
import mixins from '@@/core/mixins/mixins'
import FormModal from "@@/core/libraries/form/FormModal";
import {BButton, BCard, BCollapse, BModal, VBModal, BFormGroup, BFormInput, BTable, BTooltip, VBToggle, BFormCheckbox} from "bootstrap-vue";

export default {
    name: "CollectionOrder",
    components: {
        FormModal,Loading, BFormCheckbox,BModal,
        BTooltip, BButton, BCard, BTable, BCollapse, BFormGroup, BFormInput
    },
    directives: {
        "b-modal": VBModal,'b-toggle': VBToggle,
    },
    mixins: [mixins],
    data() {
        return {
            url: 'admin/order-transfer-logs',
            allSelected: false,
            btnStatus: false,
            itemStatus: null,
            selectedItem: Array(100).fill(false),
            fields: [
                {
                    key: "select",
                    label: "",
                },
                {
                    key: 'index',
                    label: 'ردیف'
                },
                {
                    key: 'variety_title',
                    label: 'عنوان'
                },
                {
                    key: 'quantity',
                    label: 'تعداد'
                },
                {
                    key: 'store',
                    label: 'انبار'
                },
                {
                    key: 'order_id',
                    label: 'سفارش'
                },
                {
                    key: 'created_at',
                    label: 'تاریخ سفارش'
                },
                {
                    key: 'status',
                    label: 'وضعیت'
                },
            ],
            editStatus: [
                {
                    value: 'checked',
                    name: 'جمع آوری شده',
                },
                {
                    value: 'unchecked',
                    name: 'جمع آوری نشده',
                },
            ],
        }
    },
    watch: {
        selectedItem(newVal) {
            let selectedItem = newVal.filter((item) => item != false);
            if (selectedItem != "") {
                this.btnStatus = true;
            } else {
                this.btnStatus = false;
            }
        },
    },
    mounted() {
        this.loadItems()
    },
    methods: {
        itemSelect(index, id) {
            if (!this.selectedItem[index]) {
                this.$set(this.selectedItem, index, id);
            } else {
                this.$set(this.selectedItem, index, false);
            }
        },
        itemSelectAll() {
            if (this.allSelected) {
                document
                .querySelectorAll("input[notselected]")
                .forEach((e) => e.click());
            } else {
                document.querySelectorAll("input[selected]").forEach((e) => e.click());
            }
        },
        async updateStatus() {
            let selectedItem = this.selectedItem.filter((item) => item != false);
            try {
                const response = await this.$axios.post("admin/order-transfer-logs/change-status", {
                    status: this.itemStatus ? this.itemStatus.value : "",
                    ids: selectedItem,
                });
                this.selectedItem.forEach((item, index) => {
                    if (!item) {
                        return;
                    }
                    this.items.data[index].status = this.itemStatus.value;
                    item = false;
                });
                document.querySelectorAll("input[selected]").forEach((e) => e.click());
                this.$root.notify(response.data.message, "success");
                this.$root.$emit("bv::hide::modal", "change-status");
            } catch (error) {
                this.$root.notify(error);
            }
            this.disabled = false;
        },
    }
}
